import { render, staticRenderFns } from "./raise-order.vue?vue&type=template&id=20570f78"
import script from "./raise-order.vue?vue&type=script&lang=js"
export * from "./raise-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports